import { render } from "./HomeSwiper.vue?vue&type=template&id=3f49ebf7&scoped=true"
import script from "./HomeSwiper.vue?vue&type=script&lang=js"
export * from "./HomeSwiper.vue?vue&type=script&lang=js"

import "./HomeSwiper.vue?vue&type=style&index=0&id=3f49ebf7&scoped=true&lang=css"

import exportComponent from "D:\\projects\\APP\\vue3-ewshop\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f49ebf7"]])

export default __exports__